<style lang="less" scoped>
.intro-container {
  position: relative;
  height: 100%;
  min-height: 100%;
}
h1 {
  position: absolute;
  left: 0;
  top: 0;
  background-image: url(~@/styles/images/logo.png);
  background-repeat: no-repeat;
  width: 154px;
  height: 398px;
  color: transparent;
  font-size: 0;
}
footer {
  position: absolute;
  right: 0;
  bottom: 0;
  background-image: url(~@/styles/images/footer2.png);
  background-repeat: no-repeat;
  width: 597px;
  height: 62px;
  color: #aaa;
  font-size: 11px;
  text-align: right;
  padding-right: 20px;
  &::before {
    content: "";
    display: block;
    height: 40px;
  }
}
.contaner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 1000px;
  height: 1000px;
}

.content {
  position: relative;
  color: #ccc;
  // overflow-y: scroll;
  padding: 0 20px;
  height: 100%;
  .ps {
    height: 100%;
  }
  h2 {
    padding-top: 5px;
    font-size: 30px;
    color: #670303;
  }
  .photo {
    left: 250px;
    top: 110px;
    width: 200px;
    height: 263px;
    transform: rotate(-0.02turn);
    animation: none;
  }

  .text {
    padding: 50px 0 0 0;
    font-size: 0.9em;
    line-height: 240%;
    p {
      padding-left: 100px;
      border-bottom: 1px solid #f9f9ee;
      span {
        display: inline-block;
        width: 200px;
        text-align: right;
        padding-right: 20px;
        font-size: 18px;
        color: #670303;
        font-weight: bold;
      }
      i {
        color: #000;
      }
    }
  }

  .project-sec {
    position: relative;
    &::before {
      content: "";
      position: absolute;
      left: 14px;
      top: 0;
      width: 2px;
      height: 100%;
      background-color: #670303;
    }

    .project {
      display: flex;
      padding-bottom: 100px;
    }

    .year {
      span {
        writing-mode: vertical-rl;
        font-size: 40px;
        font-weight: bold;
        padding-right: 30px;
        color: #670303;
        // transform: rotate(180deg);
      }
    }

    .item-sec {
      width: 100%;
      text-align: center;
    }

    .item {
      padding-bottom: 30px;
      h2 {
        color: #670303;
      }
      .tech {
        padding-bottom: 10px;
        span {
          &:last-child::after {
            display: none;
          }
          &::after {
            content: ", ";
            display: inline-block;
            margin-right: 5px;
          }
        }
      }
      .img {
        img {
          display: block;
          margin: 0 auto;
          width: 450px;
        }
      }
    }
  }
}

.profile-page {
  position: absolute;
  left: 0;
  transform: translateY(-50%);
  top: 50%;
  bottom: 0;
  right: 0;
  z-index: 0;
  width: 100%;
  height: 700px;

  .bg {
    width: 0%;
    height: 100%;
    background-image: url(~@/styles/images/pager2.png);
    transition: width 0.15s ease-out;
    overflow: hidden;
    .content {
    }
  }
  &.active {
    z-index: 3;
    .bg {
      width: 100%;
      transition: width 0.1s ease-in;
      .content {
      }
    }

    .alphabet {
      opacity: 1;
    }
    .p-4 {
      top: 0px;
      left: 0px;
      transform: rotate(18deg);
    }
    .r-3 {
      top: 15px;
      left: 55px;
      transform: rotate(-8deg);
    }
    .o-3 {
      top: 20px;
      left: 100px;
      transform: rotate(-5deg);
    }
    .f-1 {
      top: 10px;
      left: 160px;
      transform: rotate(15deg);
    }
    .i-2 {
      top: 5px;
      left: 215px;
      transform: rotate(-5deg);
    }
    .l-1 {
      top: 10px;
      left: 245px;
      transform: rotate(5deg);
    }
    .e-3 {
      top: 10px;
      left: 308px;
      transform: rotate(-5deg);
    }
  }

  .content {
    width: 700px;
    margin: 0 auto;
  }

  h2.profile {
    position: relative;
    height: 120px;
  }

  .alphabet {
    opacity: 0;
    transform: rotate(180deg);
    transition: all 0.3s ease-in;
  }

  .p-4 {
    top: 0px;
    left: 0px;
  }
  .r-3 {
    top: 0;
    left: 55px;
  }
  .o-3 {
    top: 0;
    left: 100px;
  }
  .f-1 {
    top: 0;
    left: 160px;
  }
  .i-2 {
    top: 0;
    left: 215px;
  }
  .l-1 {
    top: 0;
    left: 245px;
  }
  .e-3 {
    top: 0;
    left: 308px;
  }
}

.history-page {
  position: absolute;
  left: -150%;
  transform: translateY(-50%, 0);
  top: 50%;
  bottom: 0;
  right: 0;
  z-index: 0;
  width: 400%;
  height: 700px;
  transform: rotate(-70deg);

  .bg {
    width: 0%;
    height: 100%;
    background-image: url(~@/styles/images/pager2.png);
    transition: width 0.15s ease-out;
    overflow: hidden;
    .content {
      // display: none;
    }
  }
  &.active {
    z-index: 3;
    .bg {
      width: 100%;
      transition: width 0.1s ease-in;
      .content {
        // display: block;
      }
    }

    h2.history {
      .alphabet {
        opacity: 1;
      }

      .h-1 {
        top: 0;
        left: 0;
        transform: rotate(10deg);
      }
      .i-1 {
        top: 20px;
        left: 70px;
        transform: rotate(-5deg);
      }
      .s-3 {
        top: 25px;
        left: 98px;
        transform: rotate(15deg);
      }
      .t-3 {
        top: 0;
        left: 140px;
        transform: rotate(-5deg);
      }
      .o-2 {
        top: 15px;
        left: 195px;
        transform: rotate(5deg);
      }
      .r-2 {
        top: 20px;
        left: 255px;
        transform: rotate(-15deg);
      }
      .y-1 {
        top: 10px;
        left: 300px;
        transform: rotate(15deg);
      }
    }
  }
  .content {
    // background-color: red;
    position: relative;
    right: -400px;
    width: 700px;
    margin: 0 auto;
  }
  .profile {
    padding: 50px 0 0 0;
    font-size: 0.9em;
    line-height: 240%;
    p {
      padding-left: 230px;
      border-bottom: 1px solid #f9f9ee;
    }
  }

  h2.history {
    position: relative;
    height: 120px;
    .alphabet {
      opacity: 0;
      transform: rotate(180deg);
      transition: all 0.3s ease-in;
      // margin-left: 20px;
    }
    .h-1 {
      top: -30px;
      left: 0;
    }
    .i-1 {
      top: -30px;
      left: 70px;
    }
    .s-3 {
      top: -30px;
      left: 98px;
    }
    .t-3 {
      top: -30px;
      left: 140px;
    }
    .o-2 {
      top: -30px;
      left: 195px;
    }
    .r-2 {
      top: -30px;
      left: 255px;
    }
    .y-1 {
      top: -30px;
      left: 300px;
    }
  }
}

.project-page {
  .alphabet {
    opacity: 0;
    transform: rotate(180deg);
    margin-left: 20px;
  }
  .p-3 {
    left: 0;
    top: 0;
  }
  .r-1 {
    left: 33px;
    top: 0;
  }
  .o-1 {
    left: 70px;
    top: 0;
  }
  .j-1 {
    left: 100px;
    top: 0;
  }
  .e-2 {
    left: 120px;
    top: 0;
  }
  .c-2 {
    left: 150px;
    top: 0;
  }
  .t-2 {
    left: 180px;
    top: 0;
  }

  &.active {
    .alphabet {
      opacity: 1;
    }
    .p-3 {
      left: 0;
      top: 0px;
      transform: rotate(10deg);
    }
    .r-1 {
      left: 33px;
      top: 30px;
      transform: rotate(-20deg);
    }
    .o-1 {
      left: 70px;
      top: 30px;
    }
    .j-1 {
      left: 105px;
      top: 30px;
      transform: rotate(20deg);
    }
    .e-2 {
      left: 130px;
      top: 40px;
      transform: rotate(0);
    }
    .c-2 {
      left: 160px;
      top: 30px;
      transform: rotate(-20deg);
    }
    .t-2 {
      left: 190px;
      top: 20px;
      transform: rotate(0);
    }
  }
}
h2.project {
  position: relative;
  height: 120px;
  > div {
    transition: all 0.3s ease-in;
  }
}
</style>

<template lang="pug">
  .intro-container
    h1 eyes of siche
    .project-page(:class="{ 'active' : pageProject }")
      .bg
        .content
          perfect-scrollbar(ref="scroll")
            h2.project
              .alphabet.p-3
              .alphabet.r-1
              .alphabet.o-1
              .alphabet.j-1
              .alphabet.e-2
              .alphabet.c-2
              .alphabet.t-2
            .profile
              .project-sec#project
                .project(v-for="item of project")
                  .year #[span {{ item.year }}]
                  .item-sec
                    .item(v-for="item of item.project" :key="item.name")
                      h2 {{ item.name }}
                      .tech
                        span(v-for="tech of item.tech") {{ tech }}
                      .img
                        img(:src="item.screen[0]")
    .profile-page(:class="{ 'active' : pageProfile }")
      .bg
        .content
          h2.profile
            .alphabet.p-4
            .alphabet.r-3
            .alphabet.o-3
            .alphabet.f-1
            .alphabet.i-2
            .alphabet.l-1
            .alphabet.e-3
          .text
            p 김상운, 82. 8. 11, 👨
            p 다행인지 불행인지 이번생에 얻은 이 직업은 아직까지 재미지다....
            p 끝.
            p &nbsp;
            p #[strong(style="color: #670303;") SKILL]
            p HTML, css, Javascript, jQuery #[i -이거 아직도써?], Vuejs #[i -이거쥐!]
            p PHP #[i -가물가물..], JAVA spring #[i -넘나 싫은거..], express #[i -이거쥐!]
            p mysql #[i -이거쥐!], oracle #[i -열심히가 안된다..], mongoDB #[i -열심히 해야하는디..]
            p Android #[i -깊게 발담그긴 싫다..], swift #[i -깊게 발담그긴 싫다..]
    .history-page(:class="{ 'active' : pageHistory }")
      .bg
        .content
          h2.history
            .alphabet.h-1
            .alphabet.i-1
            .alphabet.s-3
            .alphabet.t-3
            .alphabet.o-2
            .alphabet.r-2
            .alphabet.y-1
          .text
            p #[span 2020.01 ~] Blue Mobile / FrontEnd developer #[i -써먹을만한 놈]
            p #[span 2015.01 ~ 2019.12] Clubpass / CTO #[i -시간은 안 아까운 놈]
            p #[span 2013.04 ~ 2019.12] STA1.com / 개발실 (과장) #[i -봐줄만한 놈]
            p #[span 2007.06 ~ 2012.08] goover / 개발실 (대리) #[i -잡부]
            p #[span 2003.06 ~ 2004.06] Uway / Web Publisher #[i -좆밥]
            p #[span 2002.02 ~ 2002.08] 가네트 솔루션 / Web Design #[i -먼지]
    .contaner
      .photo
      .photo-link(@click="pageOpen('project')")
      //- .suspect
        .alphabet.s-1
        .alphabet.u-1
        .alphabet.s-2
        .alphabet.p-1
        .alphabet.e-1
        .alphabet.c-1
        .alphabet.t-1
      .man
      .man-1
      .man-2
      .keyboard
      .keyboard-link(@click="pageOpen('profile')")
      .eyes
      .mouse
      .deer
      .cloud
      .flag
      .earth
      .building
      .building-link(@click="pageOpen('history')")
      .pen
      .pen-2
    footer Copyright 2002 eos.pe.kr
</template>

<script>
export default {
  watch: {
    "$route.query": {
      deep: true,
      handler: function(val) {
        this.pageProject = val.page === "project";
        this.pageProfile = val.page === "profile";
        this.pageHistory = val.page === "history";
      }
    }
  },
  data() {
    return {
      pageProject: false,
      pageProfile: false,
      pageHistory: false,
      project: null,
      projectTop: 0
    };
  },
  async mounted() {
    const { data } = await this.$http.get("/project.json");
    this.project = data;

    this.projectTop = document.getElementById("project").offsetTop;
    this.$refs.scroll.$el.addEventListener("scroll", this.scroll);

    this.pageProject = this.$route.query.page === "project";
    this.pageProfile = this.$route.query.page === "profile";
    this.pageHistory = this.$route.query.page === "history";
  },
  methods: {
    pageCheck(val) {
      console.log(val);
    },
    pageOpen(page) {
      // this.page = !this.page;
      this.$router.push({ query: { page } });
    },
    scroll() {
      for (const item of document.querySelectorAll(".year")) {
        if (
          this.projectTop + item.offsetTop < this.$refs.scroll.$el.scrollTop &&
          this.projectTop + item.offsetTop + item.offsetHeight > this.$refs.scroll.$el.scrollTop
        ) {
          const top = this.$refs.scroll.$el.scrollTop - this.projectTop - item.offsetTop;
          item.childNodes[0].style.transform = `translate3d(0, ${top}px, 0)`;
        }
      }

      if (this.$refs.scroll.$el.scrollTop === 0) {
        document.querySelector(".year span").style.transform = `translate3d(0, 0px, 0)`;
      }
    }
  }
};
</script>
